import AboutUs from "@components/Site/AboutUs"
import BubblesBg from "@components/Site/BubblesBg/BubblesBg"

const Page = () => {
  return (
    <>
      <AboutUs />
      <BubblesBg variant="variant2"/>
    </>
  )
}

export default Page
